<template>
  <div>
  <vs-popup
    title="CUSTOMER LINKS"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <div v-if="loading" class="text-center py-4">Loading...</div>
      <template v-else>
        <div v-if="items.length === 0" class="text-center text-grey py-4">
          No bespoke prices or contract products linked.
        </div>
        <template v-else>
          <vs-table :data="items" hoverFlat>
            <template slot="thead">
              <vs-th>Customer</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(tr, index) in data" :key="index">
                <vs-td>
                  <hyper-link :id="tr.customer.id" type="customer">
                    {{ tr.customer.account_number }} - {{ tr.customer.company_name }}
                  </hyper-link>
                </vs-td>
                <vs-td>
                  <vs-chip transparent :color="tr.type === 'Bespoke' ? 'primary' : 'success'">{{ tr.type }}</vs-chip>
                </vs-td>
                <vs-td>
                  <vs-button v-if="tr.bespoke_price_id" v-can="'create-edit-bespoke-pricing'" size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit" @click.stop="onClickEdit(tr.customer.id, tr.bespoke_price_id, '10')" />
                  <vs-button v-if="tr.contract_id" v-can="'create-edit-product-contract'" size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit" @click.stop="onClickEdit(tr.customer.id, tr.contract_id, '9')" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination
            v-if="meta.last_page > 1"
            :total="meta.last_page"
            v-model="page"
            class="p-4"
          />
        </template>
      </template>
    </vx-card>

  </vs-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import HyperLink from '@/components/Hyperlink/HyperLink.vue'
import { defaultPagination } from '@/constants/config'

const FormulationsRepository = RepositoryFactory.get('formulations')

function initialState() {
  return {
    open: false,
    loading: false,
    items: [],
    page: 1,
    meta: {},
    formulationId: null,
  }
}

export default {
  name: 'FormulationCustomerLinksPopUp',
  components: {
    HyperLink,
  },
  data() {
    return { ...initialState(), perPage: defaultPagination }
  },
  watch: {
    page() {
      this.fetchItems()
    },
  },
  methods: {
    async openPopup(formulation) {
      Object.assign(this.$data, { ...initialState(), perPage: this.perPage })
      this.formulationId = formulation.id
      this.open = true
      await this.fetchItems()
    },
    async fetchItems() {
      this.loading = true
      try {
        const response = await FormulationsRepository.getBespokeAndContracts(
          this.formulationId,
          this.page,
          this.perPage
        )

        const data = response.data
        const full = data.data

        this.meta = data.pagination || {}

        const items = []

        for (let i = 0; i < full.length; i++) {
          const item = full[i]

          const isBespoke = item.type === 'bespoke_pricing'

          items.push({
            type: isBespoke ? 'Bespoke' : 'Contract',
            customer: item.customer,
            bespoke_price_id: isBespoke ? item.id : null,
            contract_id: !isBespoke ? item.id : null,
            contract_product_code: item.contract_product_code ? item.contract_product_code : null,
          })
        }

        this.items = items

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onClickEdit(customerId, editId, step) {
      const route = this.$router.resolve({ name: 'manage-customer_details', params: { id: customerId }, query: { step, edit_id: editId } })
      window.open(route.href, '_blank')
    },
  },
}
</script>
